export default {"src":"/_next/static/media/logo-mobile.9a01e46f.svg","height":40,"width":139,"blurWidth":0,"blurHeight":0};